import React from 'react';
import styled from 'styled-components/macro';
import { Input } from '../SubComponents/Inputs';
import { Button } from '../SubComponents/Buttons';
import useLocalize from '../Hooks/useLocalize';

const RecipientFormContainer = styled.form`
  display: flex;
  flex-wrap: wrap;
  /* Negativ margin to remove extra margin */
  margin: -32px 0 0 -25px;
  margin-bottom: 32px;
`;

interface RecipientFormProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  mobileButton?: boolean;
}

const RecipientForm = (props: RecipientFormProps) => {
  const localize = useLocalize();

  const handleSubmit = (event: React.ChangeEvent<HTMLFormElement>) => {
    event.preventDefault();
    props.onSubmit();
  };

  const placeholder = `${localize('recipient.name')} (${localize('giftcard.optional')})`;

  return (
    <RecipientFormContainer onSubmit={handleSubmit}>
      <Input
        type="text"
        name="name"
        onChange={props.onChange}
        value={props.value}
        placeholder={placeholder}
        m="32px 0 0 25px"
        flex="0 1 calc(50% - 25px)"
      />

      <Button type="submit" mobile={props.mobileButton} mt="4" ml="auto">
        {localize('product.next')}
      </Button>
    </RecipientFormContainer>
  );
};

export default RecipientForm;
